import { c as _c } from "react/compiler-runtime";
import { useGetBulkDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-helper";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { bulkActionResultsSelector, numberOfUpdatingItemsSelector } from "@store/table/table-selector";
import { useAppSelector } from "@store/store-helper";
import { nounPluralize } from "@utils/data-display";

/** Determines the content of bulk dialog and bulk success dialog for changing project management */
export function useChangeProjectManagementBulkDialogContent() {
  const $ = _c(17);
  const numberOfUpdatingItems = useAppSelector(numberOfUpdatingItemsSelector);
  const {
    numberOfSuccess,
    numberOfErrors
  } = useAppSelector(bulkActionResultsSelector);
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  const changedNoun = canAssignManagers ? "management" : "group";
  const t0 = `Change ${changedNoun} for these projects?`;
  const t1 = `When you confirm this action, the selected projects will be moved to the new group${canAssignManagers ? " and manager" : ""}`;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      title: t0,
      description: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `Couldn't change the ${changedNoun} of ${numberOfErrors} out of ${numberOfUpdatingItems} projects`;
  const t4 = `The ${changedNoun} of these projects couldn't be changed, check the details and try again.`;
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = {
      title: t3,
      description: t4
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t5) {
    t6 = {
      initial: t2,
      failed: t5,
      confirmButtonText: "change",
      entityType: "project"
    };
    $[6] = t2;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const bulkDialogContent = useGetBulkDialogContent(t6);
  let t7;
  if ($[9] !== numberOfSuccess) {
    t7 = nounPluralize({
      counter: numberOfSuccess,
      word: "project"
    });
    $[9] = numberOfSuccess;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = `${t7} changed ${changedNoun}.`;
  const t9 = `The ${changedNoun} of the selected projects was successfully changed.`;
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = {
      title: t8,
      description: t9
    };
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const successDialogContent = t10;
  let t11;
  if ($[14] !== bulkDialogContent || $[15] !== successDialogContent) {
    t11 = {
      bulkDialogContent,
      successDialogContent
    };
    $[14] = bulkDialogContent;
    $[15] = successDialogContent;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}